export default __webpack_public_path__ + "static/media/image.guardians-management-solutions-pvt-ltd.a8e17875.png";